export const GET_SCHEDULE_CONFIG_LIST = 'GET_SCHEDULE_CONFIG_LIST';
export const SET_SCHEDULE_CONFIG_LIST = 'SET_SCHEDULE_CONFIG_LIST';
